module.exports = __webpack_public_path__ + "img/logo-llp.bc07b9c1.png";